(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/oddsmind-chat/assets/javascripts/oddsmind-chat-react-component.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/oddsmind-chat/assets/javascripts/oddsmind-chat-react-component.js');
'use strict';

const {
  oddsmindNavigate
} = svs.oddset_kambi.components.oddsmind_chat;
const oddsmindConfig = svs.oddset_kambi.data.oddsmindConfig;
const {
  useEffect,
  useRef,
  useState,
  useCallback
} = React;
const {
  kambiEnv: environment
} = svs.oddset_kambi.data;
const {
  getOddsmindOffset
} = svs.oddset_kambi.components.common.utils;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
svs.oddsmind = svs.oddsmind || {};
const OddsmindChatReactComponent = _ref => {
  let {
    isSmallScreen
  } = _ref;
  svs.oddsmind.isSmallScreen = isSmallScreen; 
  const oddsmindRef = useRef(null);
  const [headerVisible, setHeaderVisible] = useState(true);
  const intersectionCallback = useCallback(entries => {
    entries.forEach(entry => {
      setHeaderVisible(entry.isIntersecting);
    });
  }, []);
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };
    const observer = new IntersectionObserver(intersectionCallback, options);
    const page = document.querySelector('.js-top-content-wrapper');
    if (page) {
      observer.observe(page);
    }
    return () => {
      if (page) {
        observer.unobserve(page);
      }
    };
  }, [intersectionCallback]);
  useEffect(() => {
    const oddsmindElement = oddsmindRef.current;
    if (!oddsmindElement) {
      return undefined;
    }
    const handleBetIntercept = e => {
      e.preventDefault();
      svs.components.analytics.trackEvent({
        category: 'oddset',
        action: 'oddsmind',
        opt_label: 'send to betslip'
      });
      oddsmindNavigate(e.detail);
    };
    const handleWidgetOpened = () => {
      svs.components.analytics.trackEvent({
        category: 'oddset',
        action: 'oddsmind',
        opt_label: 'initiate oddsmind'
      });
    };
    oddsmindElement.addEventListener('bet_intercept', handleBetIntercept);
    oddsmindElement.addEventListener('oddsmind:widget_opened', handleWidgetOpened);
    return () => {
      oddsmindElement.removeEventListener('bet_intercept', handleBetIntercept);
      oddsmindElement.removeEventListener('oddsmind:widget_opened', handleWidgetOpened);
    };
  }, []);
  return React.createElement("oddsmind-chat", {
    "api-url": environment === 'prod' ? 'https://prod.oddsmind.ai' : 'https://chat.oddsmind.ai',
    backdrop: "none" 
    ,
    badge: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.badgeText) || ''),
    "bookmaker-id": "32",
    "bottom-offset": getOddsmindOffset({
      isLoggedIn,
      isSmallScreen
    }).bottom,
    "client-id": "svenskaspel",
    country: "SE",
    "footer-label": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.linkText) || 'OddsMind'),
    "footer-note": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.footerNote) || ''),
    "footer-prefix": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.footerPrefix) || ''),
    "footer-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.link) || 'https://oddsmind.ai') 
    ,
    "header-image-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.headerImage) || '') 
    ,
    "icon-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.iconUrl) || '') 
    ,
    "intercept-bets": "true",
    language: "sv",
    "launcher-image-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.openOddsmindImage) || '') 
    ,
    "launcher-image-url-mobile": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.openOddsmindImageMobile) || '') 
    ,
    mode: "floating" 
    ,
    "parent-origin": "".concat(window.location.origin)
    ,
    position: "bottom-right",
    ref: oddsmindRef,
    subtitle: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.subheader) || 'AI Betting Assistant'),
    title: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.header) || 'OddsMind'),
    "top-offset": getOddsmindOffset({
      isLoggedIn,
      isSmallScreen,
      headerVisible
    }).top
    ,
    welcome: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.welcomeMessage) || 'Hej! Jag är din AI-assistent för spel på fotboll — just nu med fokus på VM 2026. Fråga mig om en match, ett lag eller en spelare så ger jag dig statistik och ett spelförslag. Jag kan inte allt ännu, men lär mig hela tiden!')
    ,
    "widget-key": "widget_sOpEbLybS6h5QD201n6JpMZ12shh4_bvBGRfMO7e8E0" 
    ,
    "z-index": "301"
  });
};
setGlobal('svs.oddset_kambi.components.oddsmind_chat.OddsmindChatReactComponent', OddsmindChatReactComponent);

 })(window);